<template>
  <div class="dimissionContainer">
    <a-form :form="form" @submit="handleSubmit">
      <a-form-item label="姓名：" v-if="detail != ''" v-bind="formItemLayout">
        <p>{{ detail.name }}</p>
      </a-form-item>
      <a-form-item
        label="联系电话："
        v-if="detail != ''"
        v-bind="formItemLayout"
      >
        <p>{{ detail.phone }}</p>
      </a-form-item>
      <a-form-item label="项目：" v-if="proList != ''" v-bind="formItemLayout">
        <a-select
          v-decorator="[
            'project_id',
            { rules: [{ required: true, message: '请选择类型项目!' }] }
          ]"
        >
          <a-select-option
            v-for="(element, j) in proList"
            :key="j"
            :value="element.project_id"
            >{{ element.project_name }}</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item label="离职时间：" v-bind="formItemLayout">
        <a-date-picker
          v-decorator="[
            'leave_time',
            { rules: [{ required: true, message: '请选择离职时间!' }] }
          ]"
        />
      </a-form-item>
      <a-form-item
        label="离职原因："
        v-if="reasonList != ''"
        v-bind="formItemLayout"
      >
        <a-select
          v-decorator="[
            'reason',
            { rules: [{ required: true, message: '请选择离职原因!' }] }
          ]"
          @change="reasonSelect"
        >
          <a-select-option
            v-for="(element, j) in reasonList"
            :key="j"
            :value="element"
            >{{ element }}</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item v-if="includesShow" label="其他：" v-bind="formItemLayout">
        <a-textarea
          v-model="reasonTxt"
          :autoSize="{ minRows: 3, maxRows: 5 }"
        />
      </a-form-item>
      <a-form-item label="是否结算" v-bind="formItemLayout">
        <a-radio-group
          v-decorator="[
            'is_settlement',
            { rules: [{ required: true, message: '请选择是否结算!' }] }
          ]"
        >
          <a-radio :value="2">
            结算
          </a-radio>
          <a-radio :value="1">
            不结算
          </a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
        <a-button @click="backPage" style="margin-right:20px;">返回</a-button>
        <a-button type="primary" html-type="submit">提交</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
let getToday = "";
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      detail: {},
      formLayout: "horizontal",
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 12 }
      },
      form: this.$form.createForm(this),
      proList: [],
      reasonList: [
        "新人不适应",
        "报备离职，另有发展",
        "消极怠工，劝退",
        "不服从管理",
        "吃不了苦",
        "家有急事，辞职",
        "其他"
      ],
      dimissionDate: "",
      reasonTxt: "",
      includesShow: false
    };
  },
  props: {
    dimissionDetail: {}
  },
  mounted() {
    this.detail = this.dimissionDetail;
    // console.log(this.detail)
    // if (this.detail.user_id != "" && this.detail.user_id != undefined) {
    //   this.getProject();
    // }
    this.getTime();
  },
  watch: {
    dimissionDetail() {
      this.detail = this.dimissionDetail;
      this.getProject();
      // console.log(  this.detail )
    }
  },
  methods: {
    reasonSelect(val) {
      if (val == "其他") {
        this.includesShow = true;
      }
    },
    getTime() {
      this.dimissionDate = moment().format("YYYY-MM-DD");
    },
    getProject() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.resume +
        "Resume/queryUserEntryInfo";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        user_id: this.detail.user_id
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.proList = res.data.data;
        }
      });
    },
    handleSubmit(e) {
      e.preventDefault();
      let _this = this;
      this.form.validateFields((err, values) => {
        if (!err) {
          let reason;
          this.includesShow
            ? (reason = this.reasonTxt)
            : (reason = values.reason);
          let params = {
            token: window.localStorage.getItem("xnwfPcToken"),
            user_id: this.detail.user_id,
            project_id: values.project_id,
            reason: reason,
            is_settlement: values.is_settlement,
            leave_time: moment(values.leave_time).format("YYYY-MM-DD")
          };
          let url =
            this.httpsBasic.url +
            this.httpsBasic.resume +
            "Resume/resumeLeaveNew";
          if (reason != "") {
            axios
              .post(url, params)
              .then(res => {
                if (res.data.code == 200) {
                  this.$message.success("离职成功");
                  this.handleReset();
                  // this.$router.push({ name: "resume" });
                  this.$emit("hideInDimission", true);
                } else {
                  this.$message.warning(res.data.message);
                }
              })
              .catch(err => {
                this.$message.error("服务器出错了...");
              });
          } else {
            this.$message.warning("请填写离职原因");
          }
        }
      });
    },
    backPage() {
      this.$emit("hideInDimission", false);
    },
    handleReset() {
      this.form.resetFields();
      this.reasonTxt = "";
    }
  }
};
</script>
<style lang="less" scoped>
.dimissionContainer {
  h2 {
    line-height: 52px;
    // font-weight: normal;
    font-size: 16px;
    margin-left: 30%;
  }
  .ant-form-item {
    line-height: 30px;
    margin-bottom: 14px;
  }
}
</style>
